import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "faq__button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "faq__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "31.835",
  height: "18.039",
  viewBox: "0 0 31.835 18.039"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "elemek",
    transform: "translate(-0.069 -0.299)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Path_36",
      "data-name": "Path 36",
      d: "M1.13,1.36,15.987,16.217,30.844,1.36",
      transform: "translate(0 0)",
      fill: "none",
      stroke: "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "3"
    })
  ])
], -1)
const _hoisted_3 = { class: "faq__dropdown" }
const _hoisted_4 = { class: "faq__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["faq__item", {'faq__item--open': _ctx.openState}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openState = !_ctx.openState))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title"),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}